import React, { useContext } from "react";
import { makeStyles } from "@material-ui/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import { AppContext, DispatchContext } from "../../AppContext";
import * as actions from "../../actions/actions";
import { Popover, Box } from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import SettingsIcon from '@material-ui/icons/Tune';
import UndoIcon from '@material-ui/icons/Undo';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import plagWareLogo from '../../assets/plagaware-logo-lightblue-150.png';
import { ReactComponent as CoinsIcon } from '../../assets/coins.svg';
import Service from "../../services/service";
import PaymentDialog from "../../components/PaymentDialog";
import SettingsDialog from "../../components/SettingsDialog";
import LanguageMenu from "../../components/LanguageMenu";
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import { ReactComponent as WandIcon } from '../../assets/icons/wand.svg';
import { config, getCookie, navigateToBackendUrl } from '../../helpers/constants';


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    height: '64px'
  },
  flex: {
    flex: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 10,
    marginTop: 0,
    color: "white",
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.2)"
    }
  },
  menuItem: {
    paddingLeft: 32,
    paddingRight: 32,

  },
  navLogo: {
    width: "150px",
    cursor: "pointer",
    paddingTop: 8
  },
  appBar: {
    backgroundColor: "#1363A8",
    backgroundImage: "url(/gfx/background-blue.jpg)",
  },
}));

export default function TitleBar(props) {
  const dispatch = useContext(DispatchContext);
  const state = useContext(AppContext);
  const s = state.strings;
  const classes = useStyles();
  const [accountPopup, setAccountPopup] = React.useState(null);

  const handleClick = (event) => {
    setAccountPopup(event.currentTarget);
  };

  const handleClickCreditsButton = () => {
    dispatch(actions.openPaymentDialog(true));
  };

  const handleClickSettingsButton = () => {
    dispatch(actions.setUI({ settingsDialogVisible: true }));
  };

  const handleClickProfileButton = () => {
    handleClose();
    dispatch(actions.setUI({ profileDialogVisible: true }));
  };

  const onUndoButtonClicked = () => {
    Service.returnToSession().then(res => {
      if (res.success) {
        window.location.href = config.backendUrl + "pa-admin";
      }
    });
  }

  const handleClose = () => {
    setAccountPopup(null);
  };

  const login = () => {
    setAccountPopup(null);
    dispatch(actions.navigate_to("/login"));
  };

  const logout = () => {
    setAccountPopup(null);
    Service.logout().then(res => {
      // reload instead of navigate to get rid of all state 
      //navigateToBackendUrl("");
      window.location.href = config.frontendUrl;
    });
  };

  const register = () => {
    setAccountPopup(null);
    dispatch(actions.navigate_to("/signup"));
  };

  const credits = () => {
    return (state.user.totalCredits == 9999) ? s.dashboard.unlimited : state.user.totalCredits;
  }

  const onMessageButtonClicked = () => {
    dispatch(actions.navigate_to("/contact"));
  }

  const onWizardButtonClicked = () => {
    dispatch(actions.navigate_to("/wizard"));
  }

  const onLogoClicked = () => {
    window.location.href = config.backendUrl + s.links.home;
  }




  return (
    <div className={classes.root}>
      <PaymentDialog />
      <SettingsDialog />
      <AppBar position="static" className={classes.appBar}>
        <Toolbar>
          {!state.ui.permaLinkId ?
            <>
              <IconButton
                className={classes.menuButton}
                aria-label="Menu"
                onClick={() => dispatch(actions.setUI({ leftPanelVisible: !state.ui.leftPanelVisible }))}>
                <MenuIcon />
              </IconButton>
              <Typography variant="button" color="inherit" className={classes.flex}>
                <img src={plagWareLogo} className={classes.navLogo} onClick={onLogoClicked} alt="plagWareLogo" />
              </Typography>
              <Button className={classes.menuButton} onClick={onWizardButtonClicked} data-for="globalTT" data-tip={s.wizard.wizardTip}>
                <WandIcon height={20} width={20} fill="white" style={{ marginRight: 0 }} />
              </Button>
              <Button className={classes.menuButton} onClick={onMessageButtonClicked} >
                <MailOutlineIcon style={{ marginRight: 4 }} />
              </Button>
              <Button className={classes.menuButton} style={{ width: 90 }} onClick={handleClickCreditsButton} >
                <CoinsIcon height={20} width={20} fill="white" style={{ marginRight: 8 }} />
                {credits()}
              </Button>
              <Button className={classes.menuButton} onClick={handleClickSettingsButton}>
                <SettingsIcon />
              </Button>
              <Typography variant="body2">
                <Button className={classes.menuButton} onClick={handleClick}>
                  <AccountCircleIcon style={{ marginRight: 8 }} />
                  {state.user.sessionId && state.user.mailRepresentation}
                  <ExpandMoreIcon />
                </Button>
                <Popover
                  anchorEl={accountPopup}
                  keepMounted
                  open={!!accountPopup}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                  }}>
                  <Box mt={1} />
                  {state.user.guest && <MenuItem className={classes.menuItem} onClick={login}>{s.login}</MenuItem>}
                  {state.user.guest && <MenuItem className={classes.menuItem} onClick={register}>{s.register}</MenuItem>}
                  {!state.user.guest && <MenuItem className={classes.menuItem} onClick={handleClickProfileButton}>{s.profile}</MenuItem>}
                  {!state.user.guest && <MenuItem className={classes.menuItem} onClick={logout}>{s.logout}</MenuItem>}
                  <Box mt={1} />
                </Popover>
              </Typography>
              {state.user.isOtherUser &&
                <Button className={classes.menuButton} onClick={onUndoButtonClicked}>
                  <UndoIcon />
                </Button>
              }
            </>
            :
            <Typography variant="button" color="inherit" className={classes.flex}>
              <img src={plagWareLogo} className={classes.navLogo} alt="plagWareLogo" />
            </Typography>
          }
          <LanguageMenu />
        </Toolbar>
      </AppBar>
    </div>
  );
}
